
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/infrastructure",
      function () {
        return require("private-next-pages/infrastructure.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/infrastructure"])
      });
    }
  